define('lisAnaCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'dialogFormView',
  'template!lisAnaCreateEditLayoutTpl',
  'savingBehavior',
  'bootbox',
  'underscore',
  'app',
  'autocompleteView'
], function(
  module,
  Marionette,
  Backbone,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  bootbox,
  _,
  App,
  AutocompleteView
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      colorBtn: '.colorpick'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm'
    },

    regions: {
      selectLmbAna: '.js-select-lmbana-region'
    },

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'}
    ],

    initialize: function(options) {
      this.model = options.lisAnaModel.clone();
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function() {
      $.material.init();

      var lmbAnaView = new AutocompleteView(
          this._getAutocompleteOptions('refLmbAna', 'code', 'code',
              'v2/lmbanas',
              'selectlmbana.placeholder', 'code')
      );
      this.getRegion('selectLmbAna').show(lmbAnaView);

      this.triggerMethod('enable:cancel:confirm');
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    onSave: function(model) {
      var modelJSON = model.toJSON();
      this.options.lisAnaModel.set(modelJSON);
      this.triggerMethod('saved');
      App.trigger('lisana:header:rerender', modelJSON);
      this.hide();
    },

    hide: function() {
      var lisSecId = this.model.get('refLis')?this.model.get('refLis').secId:null;
      var secId = this.model.get('secId');
      this.triggerMethod('hide');
      this.box.modal('hide');
      this.destroy();
      if (secId && lisSecId && App.getCurrentRoute() ===  'admin/lis/'+lisSecId+'/lisana/new') {
        App.navigate('admin/lisanas/' + secId, {trigger: true});
      } else if (!secId && lisSecId) {
        App.navigate('admin/lis/'+lisSecId+'/lisana', {trigger: true});
      }
    },

    onSaveError: function(model, response) {
      if(response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    },

    onDuplicateCode: function() {
      this.ui.endUserIdInput.popover('show');
      this.ui.endUserIdInput.addClass('invalid');
      this.ui.endUserIdInput.closest('div[data-field-name=code').addClass('has-error');
    }
  });

  module.exports = CreateEditLayoutView;
});
